import React, { Component } from "react";
import project from "../config";
const projectLogo = require(`../assets/${project.assets}/img/projectLogo.png`);

class Spinner extends Component {

	render() {
		let { showSpinner } = this.props;
		let mainDivClass = "spinner";
		let messageText = "Loading...";
		let loadingCSS = "loadingSpinner02";
		let backBtnClass = "loadingBackBtn hide";
		// console.log(isUEFailed);

		if (!showSpinner) {
			mainDivClass = "spinner hide";
			loadingCSS = "loadingSpinner02";
		}

		return (
			<div className={mainDivClass}>
				<img src={projectLogo} alt="" />
				<div className={loadingCSS}>
					<div className="loadingSpinner">
						<div></div>
					</div>
				</div>
				<span>{messageText}</span>
				<a href={project.metaURL} className={backBtnClass}>
					zurück
				</a>
			</div>
		);
	}
}

export default Spinner;
